import {
  OrganizationDashboardPath,
  OrganizationsPath,
  ProfileDashboardPath
} from '../../../routing';
import React, { useCallback, useEffect } from 'react';
import { generatePath, useHistory } from 'react-router-dom';

import { AccountDashboardTypeResource } from '@datarock/api-client';
import AsyncBoundary from '../../../components/AsyncBoundary';
import ConfirmModal from '../../../components/ConfirmModal';
import { DOMAIN } from '../../../consts';
import FullscreenLoader from '../../../components/FullscreenLoader';
import NetworkErrorMessage from '../../../components/NetworkErrorMessage';
import strings from '../../../strings';
import { useAuth } from 'oidc-react';
import { useSuspense } from '@data-client/react';

function Authorized() {
  const auth = useAuth();
  const history = useHistory();

  const dashboardType = useSuspense(
    AccountDashboardTypeResource.get,
    auth.userData
      ? {
          accountId: auth.userData.profile.sub
        }
      : null
  );

  useEffect(() => {
    if (DOMAIN === 'user') {
      history.push(ProfileDashboardPath);
    }
    if (DOMAIN === 'admin') {
      switch (dashboardType?.type) {
        case 'MULTIPLE':
          history.push({
            pathname: OrganizationsPath
          });
          break;
        case 'RESELLER':
          history.push({
            pathname: OrganizationsPath
          });
          break;
        case 'SINGLE':
          history.push({
            pathname: generatePath(OrganizationDashboardPath, {
              organizationId: dashboardType.organizationId
            })
          });
          break;
        case 'VENGAR':
          history.push({
            pathname: OrganizationsPath
          });
          break;
      }
    }
  }, [dashboardType, history]);

  const onClickUserPortal = useCallback(() => {
    auth.signOut();
    if (process.env.REACT_APP_USER_PORTAL_URL) {
      window.location.href = process.env.REACT_APP_USER_PORTAL_URL;
    }
  }, [auth]);

  if (dashboardType?.type === 'USER' && DOMAIN !== 'user') {
    return (
      <ConfirmModal
        content={strings.modalUnauthorized}
        confirmButton={strings.pageIndexUserPortalButton}
        onConfirm={onClickUserPortal}
        show
      />
    );
  }

  return null;
}

export default function AuthorizedWithSuspense() {
  return (
    <AsyncBoundary
      errorFallback={NetworkErrorMessage}
      loadingFallback={FullscreenLoader}>
      <Authorized />
    </AsyncBoundary>
  );
}
